/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Messaging_Bots_TaglineInputs */

const en_svc_messaging_bots_tagline = /** @type {(inputs: Svc_Messaging_Bots_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales and support bots where your customers already chat.`)
};

const ar_svc_messaging_bots_tagline = /** @type {(inputs: Svc_Messaging_Bots_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بوتات مبيعات ودعم حيث يتحدث عملاؤك أصلا.`)
};

const bn_svc_messaging_bots_tagline = /** @type {(inputs: Svc_Messaging_Bots_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সেলস আর সাপোর্ট বট, যেখানে আপনার কাস্টমাররা এমনিতেই চ্যাট করে।`)
};

const de_svc_messaging_bots_tagline = /** @type {(inputs: Svc_Messaging_Bots_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkaufs- und Support-Bots dort, wo Ihre Kunden ohnehin chatten.`)
};

const es_svc_messaging_bots_tagline = /** @type {(inputs: Svc_Messaging_Bots_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bots de ventas y soporte donde sus clientes ya conversan.`)
};

const fr_svc_messaging_bots_tagline = /** @type {(inputs: Svc_Messaging_Bots_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des bots de vente et de support là où vos clients discutent déjà.`)
};

const pt_svc_messaging_bots_tagline = /** @type {(inputs: Svc_Messaging_Bots_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bots de vendas e suporte onde os seus clientes já conversam.`)
};

const zh_svc_messaging_bots_tagline = /** @type {(inputs: Svc_Messaging_Bots_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在客户本来就在聊天的地方面对面做销售与客服。`)
};

const tr_svc_messaging_bots_tagline = /** @type {(inputs: Svc_Messaging_Bots_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Müşterilerin zaten sohbet ettiği yerde satış ve destek botları.`)
};

const ru_svc_messaging_bots_tagline = /** @type {(inputs: Svc_Messaging_Bots_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сейлз- и саппорт-боты там, где ваши клиенты уже общаются.`)
};

const pl_svc_messaging_bots_tagline = /** @type {(inputs: Svc_Messaging_Bots_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boty sprzedażowe i wsparcia tam, gdzie klienci i tak już rozmawiają.`)
};

/**
* | output |
* | --- |
* | "Sales and support bots where your customers already chat." |
*
* @param {Svc_Messaging_Bots_TaglineInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_messaging_bots_tagline = /** @type {((inputs?: Svc_Messaging_Bots_TaglineInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Messaging_Bots_TaglineInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_messaging_bots_tagline(inputs)
	if (locale === "bn") return bn_svc_messaging_bots_tagline(inputs)
	if (locale === "de") return de_svc_messaging_bots_tagline(inputs)
	if (locale === "es") return es_svc_messaging_bots_tagline(inputs)
	if (locale === "fr") return fr_svc_messaging_bots_tagline(inputs)
	if (locale === "pt") return pt_svc_messaging_bots_tagline(inputs)
	if (locale === "zh") return zh_svc_messaging_bots_tagline(inputs)
	if (locale === "tr") return tr_svc_messaging_bots_tagline(inputs)
	if (locale === "ru") return ru_svc_messaging_bots_tagline(inputs)
	if (locale === "pl") return pl_svc_messaging_bots_tagline(inputs)
	return en_svc_messaging_bots_tagline(inputs)
});
export { svc_messaging_bots_tagline as "svc_messaging-bots_tagline" }